import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  // const [hidden, setHidden] = useState(false);
  const [progress, setProgress] = useState(0);
  const lastY = useRef(0);
  const ticking = useRef(false);

  const toggleSidebar = () => setIsSidebarOpen((s) => !s);
  const closeSidebar = () => setIsSidebarOpen(false);

  useEffect(() => {
    const onScroll = () => {
      if (ticking.current) return;
      ticking.current = true;
      window.requestAnimationFrame(() => {
        const y = window.scrollY || window.pageYOffset;
        const doc = document.documentElement;
        const scrollHeight = doc.scrollHeight - doc.clientHeight;
        const pct =
          scrollHeight > 0
            ? Math.min(100, Math.max(0, (y / scrollHeight) * 100))
            : 0;
        setIsScrolled(y > 12);
        // const goingDown = y > lastY.current;
        // setHidden(goingDown && y > 140);
        setProgress(pct);
        lastY.current = y;
        ticking.current = false;
      });
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true } as any);
    return () => window.removeEventListener("scroll", onScroll as any);
  }, []);

  return (
    <>
      <nav
        className={[
          "fixed top-0 left-0 right-0 z-50 w-full",
          "flex items-center justify-between px-6 md:px-10 py-4",
          "backdrop-blur transition-all duration-200",
          isScrolled
            ? "bg-slate-900/50 shadow-lg py-3 rounded-lg fixed-nav"
            : "",
          "translate-y-0 max-w-[1500px] mx-auto",
        ].join(" ")}
      >
        <div className="container hidden md:flex max-w-[1440px] mx-auto grid grid-cols-3 items-center justify-between">
          <div className="text-xl font-extrabold tracking-tight brand-glow">
            <Link
              to="/"
              className="text-xl font-extrabold tracking-tight brand-glow cursor-pointer"
            >
              Budiee
            </Link>
          </div>

          <ul className="flex items-center justify-center gap-10 m-0 p-0 list-none">
            <li>
              <Link
                to="/features"
                className="text-gray-200 hover:text-white transition-colors"
              >
                Features
              </Link>
            </li>
            <li>
              <Link
                to="/pricing"
                className="text-gray-200 hover:text-white transition-colors"
              >
                Pricing
              </Link>
            </li>
          </ul>

          <div className="hidden md:flex items-center justify-end">
            <Link to="/auth" className="inline-flex">
              <span className="px-4 py-2 rounded-full btn-primary">
                Launch App
              </span>
            </Link>
          </div>
        </div>

        <div className="container flex justify-between md:hidden max-w-[1440px] mx-auto items-center">
          <div className="text-xl font-extrabold tracking-tight brand-glow">
            <Link
              to="/"
              className="text-xl font-extrabold tracking-tight brand-glow cursor-pointer"
            >
              Budiee
            </Link>
          </div>
          <button
            className={[
              "inline-flex items-center justify-end",
              "p-2 text-gray-200 transition-transform",
              isSidebarOpen ? "rotate-90" : "rotate-0",
            ].join(" ")}
            onClick={toggleSidebar}
            aria-label="Toggle menu"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-7 h-7"
              aria-hidden
            >
              <path d="M3.75 6.75h16.5a.75.75 0 0 0 0-1.5H3.75a.75.75 0 0 0 0 1.5Zm16.5 5.25H3.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5Zm0 6.75H3.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5Z" />
            </svg>
          </button>
        </div>

        <div className="absolute left-0 right-0 bottom-0 h-0.5">
          <div
            className="h-full bg-gradient-to-r from-indigo-500 to-sky-500 shadow-[0_0_10px_rgba(99,102,241,0.6)]"
            style={{ width: `${progress}%` }}
            aria-hidden
          />
        </div>
      </nav>

      {isSidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/50 transition-opacity"
          onClick={closeSidebar}
          aria-hidden
        />
      )}

      <div
        className={[
          "fixed top-0 left-0 z-50 h-full w-64 max-w-[86vw]",
          "bg-slate-950 text-gray-200 backdrop-blur",
          "transform transition-transform duration-300",
          isSidebarOpen ? "translate-x-0" : "-translate-x-full",
          "pt-16 shadow-2xl",
        ].join(" ")}
      >
        <button
          className="absolute top-4 right-4 text-3xl text-gray-200"
          onClick={closeSidebar}
          aria-label="Close menu"
        >
          &times;
        </button>
        <ul className="flex flex-col gap-6 px-8 list-none m-0">
          <li>
            <Link
              to="/"
              onClick={closeSidebar}
              className="text-gray-200 hover:text-white"
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/features"
              onClick={closeSidebar}
              className="text-gray-200 hover:text-white"
            >
              Features
            </Link>
          </li>
          <li>
            <Link
              to="/pricing"
              onClick={closeSidebar}
              className="text-gray-200 hover:text-white"
            >
              Pricing
            </Link>
          </li>
          <li>
            <Link
              to="/auth"
              onClick={closeSidebar}
              className="text-gray-200 hover:text-white"
            >
              Login
            </Link>
          </li>
          <li>
            <Link to="/auth" onClick={closeSidebar} className="inline-flex">
              <span className="w-full text-center px-6 py-3 rounded-md btn-primary">
                Launch App
              </span>
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Navbar;
